import { createSelector } from "reselect";

/**
 * figures => [ { chapterTitle: "", figures: [] }]
 */
export const getFiguresByChapter = createSelector(
  figures => figures || [],
  figures => {
    const results = [];
    let currentChapter = null;
    for (let i = 0; i < figures.length; i++) {
      const f = figures[i];
      if (f.chapterTitle !== currentChapter) {
        currentChapter = f.chapterTitle;
        results.push({
          title: f.chapterTitle,
          figures: [f]
        });
      } else {
        const last = results[results.length - 1];
        last.figures.push(f);
      }
    }
    return results;
  }
);

/**
 * { figures, toc } => [ { chapterTitle: "", figures: [], tocCfi: "" }]
 */
export const getFigureBlocksWithTocInfo = createSelector(
  state => getFiguresByChapter(state.figures),
  state => state.toc || [],
  (figureBlocks, toc) => {
    const tocMap = toc.reduce((acc, cv) => {
      if (!acc[cv.title]) {
        acc[cv.title] = [];
      }
      acc[cv.title].push(cv);
      return acc;
    }, {});
    return figureBlocks.map(block => {
      const matches = tocMap[block.title];
      const index = Fraction.Helpers.findIndexMatchingCfiFallBackToBefore(
        matches,
        el => Fraction.Helpers.stripAssertions(el.cfi),
        Fraction.Helpers.stripAssertions(block.figures[0].cfi)
      );
      if (index >= 0) {
        return {
          ...block,
          tocCfi: Fraction.Helpers.stripAssertions(matches[index].cfi)
        }
      } else {
        return null;
      }
    }).filter(item => !!item)
  }
);
